import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { PermissionComponent } from './permission.component';
@NgModule({
  imports: [CommonModule, PermissionComponent],
  exports: [PermissionComponent],
})
export class PermissionModule {}
